import { FC } from "react";

import { Button } from "react-bootstrap";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import {
  DiagnosticsServiceOrderType,
  getServiceOrderTypeValuesByType,
} from "@/_constants/serviceOrder.ts";

import { ITenant } from "../reducers";
import {
  TServiceInventoryStoreState,
  useServiceInventoryStore,
} from "../store/ServiceInventoryStore";
import ServiceOrderingAppointmentForm from "./form/ServiceOrderingAppointmentForm";
import ServiceOrderingDiagnosticsForm from "./form/ServiceOrderingDiagnosticsForm";
import ServiceOrderingInformationsForm from "./form/ServiceOrderingInformationsForm";
import ServiceOrderingKeysForm from "./form/ServiceOrderingKeysForm";
import ServiceOrderingOperatorForm from "./form/ServiceOrderingOperatorForm";
import ServiceOrderingPropertyPPPTForm from "./form/ServiceOrderingPropertyPPPTForm.tsx";
import ServiceOrderingTenantForm from "./form/ServiceOrderingTenantForm";
interface Props {
  diagnosticServiceType: DiagnosticsServiceOrderType;
}
const DiagnosticsServiceForm: FC<Props> = ({ diagnosticServiceType }) => {
  const {
    dwelling,
    currentTenants,
    key,
    isManagedByMainGroup,
    setData,
    businessServiceType,
    isConfirmed,
  } = useServiceInventoryStore((state) => state);
  const diagnosticTypeStoreValue = useServiceInventoryStore(
    (state) => state[diagnosticServiceType]
  );
  const methods = useForm<FieldValues>({
    defaultValues: {
      dwelling,
      isConfirmed,
      isManagedByMainGroup,
      [diagnosticServiceType]: diagnosticTypeStoreValue || {
        types: [],
        appointment: {},
        isOccupied: true,
      },
      currentTenants: currentTenants ||
        dwelling?.currentTenants?.map((el: ITenant) => {
          return {
            idDwelling: el.id,
            lastname: el.person.lastname,
            firstname: el.person.firstname,
            email: el.person.email,
            phone: el.person.phone,
            rentalStartDate: el.rentalStartDate,
          };
        }) || [{}],
      key,
    },
  });
  const isOccupied = methods.watch(
    `${diagnosticServiceType}.isOccupied`,
    diagnosticTypeStoreValue?.isOccupied
  );
  const onSubmit = (data: FieldValues) => {
    if (
      !(data as TServiceInventoryStoreState)[diagnosticServiceType]?.types.some(
        (type) => type.isChecked
      )
    ) {
      methods.setError(`${diagnosticServiceType}.types`, {
        type: "required",
        message: "Veuillez choisir au moins un diagnostic",
      });
      return;
    }
    const result = {
      ...data,
      businessServiceType,
    };
    setData(result as TServiceInventoryStoreState);
    toast.success(
      `${
        getServiceOrderTypeValuesByType(diagnosticServiceType)?.label
      } ajouté au panier`
    );
  };
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3 serviceOrdering_erpExpress"
      >
        <ServiceOrderingPropertyPPPTForm
          name="dwelling"
          rules={{ required: "Veuillez renseigner un bien" }}
          serviceDiagnosticType={diagnosticServiceType}
        />
        <div className="border-bottom" />
        <div /> <ServiceOrderingAppointmentForm name={diagnosticServiceType} />
        <div className="border-bottom" />
        {isOccupied && (
          <>
            <ServiceOrderingTenantForm type="current" />
            <div className="border-bottom" />
          </>
        )}
        <ServiceOrderingOperatorForm
          onExpertByDefault={true}
          specificLabel="Diagnostic"
          type={diagnosticServiceType}
        />
        <ServiceOrderingDiagnosticsForm
          name={`${diagnosticServiceType}.types`}
        />
        {!isOccupied && (
          <>
            <ServiceOrderingKeysForm name="key" />
            <div className="border-bottom" />
          </>
        )}
        <ServiceOrderingInformationsForm
          name={`${diagnosticServiceType}.comment`}
        />
        <div className="d-flex justify-content-end">
          <Button variant={"primary"} type={"submit"}>
            {diagnosticTypeStoreValue ? "Modifier" : "Ajouter"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default DiagnosticsServiceForm;
